import { warn } from "../../lib/log";
import { useEffect, useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Records the finished game anonymously (once) and returns the real % of players who got this far, null under 100 games.
export const useResultStats = (destinationIndex) => {
  const [reachedPercent, setReachedPercent] = useState(null);
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    fetch(`${API}/results`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ destination_index: destinationIndex }),
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => setReachedPercent(data?.reached_percent ?? null))
      .catch((e) => warn("Statistiche non disponibili", e));
  }, [destinationIndex]);

  return reachedPercent;
};
